module.exports = __webpack_public_path__ + "img/2.570e8c55.jpg";